import { render, staticRenderFns } from "./TheFooterBasic.vue?vue&type=template&id=03e7912b"
import script from "./TheFooterBasic.vue?vue&type=script&lang=ts"
export * from "./TheFooterBasic.vue?vue&type=script&lang=ts"
import style0 from "./TheFooterBasic.vue?vue&type=style&index=0&id=03e7912b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports